export const NewIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      width="72"
      height="60"
      viewBox="0 0 72 60"
      fill="none"
    >
      <path
        d="M47.7298 47.1592C48.9013 45.3892 49.6752 43.4292 49.6967 41.2992C49.7289 38.8692 48.7939 36.2092 49.8901 34.0892C50.4813 32.9492 51.5991 32.0892 52.7921 31.3392C55.1781 29.8392 57.9296 28.6992 60.1974 27.0892C64.4965 24.0392 65.4316 18.4792 63.5185 13.5292C61.6053 8.56922 54.2108 3.94922 47.934 3.94922C44.0111 3.94922 40.9157 5.61922 37.4226 6.43922C33.0912 7.44922 28.5664 6.06922 23.9555 5.85922C17.0984 5.54922 11.1656 8.28922 7.1566 12.0892C2.79297 16.2292 0.34245 21.7092 0.525164 27.5692C0.890592 38.8392 10.6067 48.9592 24.6434 53.2092C29.5767 54.6992 34.9506 55.1792 39.282 53.7792C42.3989 52.7692 44.7849 50.8592 46.6013 48.6792C47.0097 48.1892 47.3859 47.6892 47.7298 47.1592Z"
        fill="#F0F2F7"
      />
      <path
        d="M14.9398 44.5098L8.73828 50.2698"
        stroke="#8FA1D2"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M63.3251 9.40039L56.1133 14.0204"
        stroke="#8FA1D2"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M39.5078 49L42.0121 56.81"
        stroke="#8FA1D2"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M29.7274 15.5501L5.55546 4.60006C5.02882 4.36006 4.49142 4.89006 4.77087 5.37006L15.9164 24.2201C16.0454 24.4301 16.0024 24.6901 15.8304 24.8701L1.23482 39.3101C0.86939 39.6801 1.17033 40.2801 1.70772 40.2501L19.2268 39.3201C19.5384 39.3001 19.8071 39.5101 19.8501 39.7901L22.7951 57.7201C22.8703 58.2001 23.5367 58.3601 23.8591 57.9801L35.9397 43.5401C36.0794 43.3701 36.3266 43.2901 36.5523 43.3401L60.1332 48.5601C60.6168 48.6701 61.0145 48.2101 60.821 47.7901L53.4587 32.4601C53.319 32.1701 53.4587 31.8401 53.7704 31.7201L70.5586 25.1701C71.0745 24.9701 71.0423 24.2801 70.5049 24.1301L51.1587 18.3701C50.9437 18.3101 50.7933 18.1401 50.7503 17.9401L47.5152 1.46006C47.4292 1.02006 46.8595 0.850057 46.5156 1.16006L30.3938 15.4601C30.2111 15.6201 29.9424 15.6601 29.7167 15.5601L29.7274 15.5501Z"
        stroke="#425B9F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.7387 22.0412L21.3562 17.2912C20.8296 17.0512 20.2814 17.5712 20.5609 18.0512L25.2792 26.1312C25.3974 26.3412 25.3652 26.5912 25.1932 26.7712L18.9379 33.0312C18.5725 33.3912 18.8735 33.9812 19.4108 33.9512L26.6657 33.5612C26.9774 33.5412 27.246 33.7512 27.289 34.0312L28.5358 41.6912C28.611 42.1712 29.2881 42.3312 29.5998 41.9412L34.7481 35.7112C34.8878 35.5412 35.135 35.4612 35.3607 35.5112L45.7216 37.8312C46.2053 37.9412 46.6137 37.4912 46.4095 37.0712L43.2926 30.5012C43.1636 30.2212 43.2926 29.8912 43.6043 29.7712L50.5259 27.0412C51.0311 26.8412 50.9988 26.1712 50.4722 26.0112L42.2608 23.5412C42.0566 23.4812 41.8954 23.3112 41.8524 23.1112L40.4552 15.9112C40.3692 15.4712 39.7888 15.3012 39.4449 15.6112L32.3943 21.9412C32.2116 22.1012 31.9429 22.1412 31.7064 22.0412H31.7387Z"
        fill="#75CDEA"
      />
    </svg>
  );
};

export const MissingBooksIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    width="72"
    height="59"
    viewBox="0 0 72 59"
    fill="none"
  >
    <path
      d="M7.02114 36.8806C-0.349859 31.7306 -1.96426 23.7906 2.40099 16.8806C5.87407 11.3806 14.9551 13.7306 20.9878 12.4206C32.1824 9.99062 31.0884 4.04062 41.1253 3.41062C53.9236 2.60062 74.4329 14.3206 68.0177 31.0906C64.0455 41.4806 59.5846 38.4106 54.614 46.8406C51.9056 51.4406 48.337 61.2006 35.7192 58.3006C21.3489 55.0006 27.1268 50.9506 7.03176 36.8906L7.02114 36.8806Z"
      fill="#F0F2F7"
    />
    <path
      d="M70.9374 15.7402H62.2812"
      stroke="#8FA1D2"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M66.0826 6.15039L59.9648 11.9104"
      stroke="#8FA1D2"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M55.4297 2.07031V10.2203"
      stroke="#8FA1D2"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M38.8514 1H12.2032C10.9303 1 9.89844 1.97154 9.89844 3.17V40.45C9.89844 41.6485 10.9303 42.62 12.2032 42.62H38.8514C40.1243 42.62 41.1561 41.6485 41.1561 40.45V3.17C41.1561 1.97154 40.1243 1 38.8514 1Z"
      stroke="#425B9F"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M33.8704 5.32031H17.1954C15.9225 5.32031 14.8906 6.29185 14.8906 7.49031V27.3403C14.8906 28.5388 15.9225 29.5103 17.1954 29.5103H33.8704C35.1433 29.5103 36.1752 28.5388 36.1752 27.3403V7.49031C36.1752 6.29185 35.1433 5.32031 33.8704 5.32031Z"
      fill="#75CDEA"
    />
    <path
      d="M36.1752 33.3594H14.8906V36.3994H36.1752V33.3594Z"
      fill="#75CDEA"
    />
    <path
      d="M55.8554 14.4414H32.0324C30.9531 14.4414 30.0781 15.2652 30.0781 16.2814V49.5314C30.0781 50.5476 30.9531 51.3714 32.0324 51.3714H55.8554C56.9347 51.3714 57.8096 50.5476 57.8096 49.5314V16.2814C57.8096 15.2652 56.9347 14.4414 55.8554 14.4414Z"
      fill="#AEE1F2"
    />
    <path
      d="M51.426 18.2695H36.4504C35.3711 18.2695 34.4961 19.0933 34.4961 20.1095V37.8995C34.4961 38.9157 35.3711 39.7395 36.4504 39.7395H51.426C52.5053 39.7395 53.3803 38.9157 53.3803 37.8995V20.1095C53.3803 19.0933 52.5053 18.2695 51.426 18.2695Z"
      fill="#75CDEA"
    />
    <path
      d="M53.3803 43.1699H34.4961V45.8699H53.3803V43.1699Z"
      fill="#75CDEA"
    />
  </svg>
);

export const SupportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    width="72"
    height="56"
    viewBox="0 0 72 56"
    fill="none"
  >
    <path
      d="M24.3233 47.2798C17.0633 46.2298 5.88865 38.7498 2.1163 33.1198C-1.65605 27.4798 -0.19185 23.0098 5.18705 19.8098C9.39663 17.3098 17.3887 18.0898 22.5236 15.8198C26.7535 13.9498 29.9361 9.51981 36.1386 6.72981C42.758 3.75981 61.1317 5.19981 69.2153 15.1298C75.2043 22.4798 69.8254 25.8498 68.8391 35.9198C68.3714 40.7198 73.4452 50.8398 62.1282 54.1798C46.7032 58.7398 44.1104 50.1498 24.3132 47.2798H24.3233Z"
      fill="#F0F2F7"
    />
    <path
      d="M14.0508 43.4102V45.9702C14.0508 49.0902 16.6233 51.6202 19.7957 51.6202H31.672"
      stroke="#425B9F"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M37.6115 47.7598H30.87C29.1404 47.7598 27.7383 49.1387 27.7383 50.8398V52.4198C27.7383 54.1208 29.1404 55.4998 30.87 55.4998H37.6115C39.3411 55.4998 40.7432 54.1208 40.7432 52.4198V50.8398C40.7432 49.1387 39.3411 47.7598 37.6115 47.7598Z"
      fill="#75CDEA"
    />
    <path
      d="M13.8281 29.39C13.8281 29.29 13.8281 22.28 13.8281 22.28C13.818 10.53 23.5081 1 35.4556 1C47.403 1 57.0932 10.53 57.0932 22.28V29.08C57.0932 29.5 57.083 29.92 57.0525 30.33"
      stroke="#425B9F"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M17.9876 28.5393C17.9876 26.8893 16.4522 25.6593 14.805 25.9593C9.95484 26.8193 6.45703 29.2993 6.45703 34.5993C6.45703 39.8993 9.99551 42.4293 14.9067 43.2593C16.5234 43.5293 17.9876 42.2693 17.9876 40.6593V28.5393Z"
      fill="#AEE1F2"
    />
    <path
      d="M53.0781 40.9792C53.0781 42.6292 54.6135 43.8592 56.2607 43.5592C61.1109 42.6992 64.6087 40.2192 64.6087 34.9192C64.6087 29.6192 61.0702 27.0892 56.159 26.2592C54.5423 25.9892 53.0781 27.2492 53.0781 28.8592V40.9792Z"
      fill="#AEE1F2"
    />
    <path
      d="M54.093 50.1211H44.6875"
      stroke="#8FA1D2"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M48.8179 39.2305L42.168 45.7705"
      stroke="#8FA1D2"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M37.2344 34.5996V43.8596"
      stroke="#8FA1D2"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const MyOrderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    width="72"
    height="73"
    viewBox="0 0 72 73"
    fill="none"
  >
    <path
      fill="#F0F2F7"
      d="M13.5147 45.5926c-6.83933-4.7785-8.33728-12.1459-4.28688-18.5575 3.22258-5.1033 11.64858-2.9228 17.24618-4.1383 10.3872-2.2547 9.3721-7.7756 18.6851-8.3601 11.8752-.7516 30.9052 10.1231 24.9528 25.6835-3.6858 9.6406-7.8249 6.7921-12.437 14.614-2.513 4.2683-5.8243 13.3243-17.532 10.6335-13.3338-3.062-7.9727-6.8199-26.6183-19.8658l-.0099-.0093Z"
    />
    <path
      stroke="#8FA1D2"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="m33 52.4995 7.28.0327"
    />
    <path
      fill="#AEE1F2"
      d="M58.8156 31H47.4987v18.75h10.3088c3.1029 0 5.4565-2.7967 4.9266-5.8539l-1.9479-11.2377C60.6201 31.6999 59.7884 31 58.8156 31Z"
    />
    <path
      fill="#75CDEA"
      d="M17.4988 25.5c0-1.1046.8954-2 2-2h27.25c1.1045 0 2 .8954 2 2v24.25h-29.25c-1.1046 0-2-.8954-2-2V25.5Z"
    />
    <circle cx="26.2488" cy="49.75" r="3.75" fill="#425B9F" />
    <circle cx="48.7487" cy="49.75" r="3.75" fill="#425B9F" />
    <path
      stroke="#425B9F"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M1.99977 30.5H12.8199M4.00159 36.0145l11.02801-.0004"
    />
    <rect width="7" height="5" x="51" y="35.5" fill="#75CDEA" rx="1" />
    <rect width="24" height="8" x="21" y="27.5" fill="#AEE1F2" rx="1" />
  </svg>
);

export const NewOrderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
  >
    <g clipPath="url(#newordericon_clip_path_a)">
      <path
        fill="#F0F2F7"
        d="M24.3233 55.2798c-7.26-1.05-18.43465-8.53-22.207-14.16-3.77235-5.64-2.30815-10.11 3.07075-13.31 4.20958-2.5 12.20165-1.72 17.33655-3.99 4.2299-1.87 7.4125-6.3 13.615-9.09 6.6194-2.97 24.9931-1.53 33.0767 8.4 5.989 7.35.6101 10.72-.3762 20.79-.4677 4.8 4.6061 14.92-6.7109 18.26-15.425 4.56-18.0178-4.03-37.815-6.9h.0101Z"
      />
      <path
        fill="#75CDEA"
        fillRule="evenodd"
        d="M30.4185 55.071c-1.5792 0-2.8608 1.2816-2.8608 2.8607s1.2816 2.8607 2.8608 2.8607c1.5791 0 2.8607-1.2816 2.8607-2.8607s-1.2816-2.8607-2.8607-2.8607Zm19.0716 0c-1.5792 0-2.8608 1.2816-2.8608 2.8607s1.2816 2.8607 2.8608 2.8607c1.5791 0 2.8607-1.2816 2.8607-2.8607s-1.2816-2.8607-2.8607-2.8607Zm6.2224-27.9332c-.3604-.4292-.8944-.6752-1.4551-.6752H25.3353L23.678 20.251c-.2212-.8353-.9784-1.417-1.8423-1.417h-5.7215c-1.0528 0-1.9072.8544-1.9072 1.9071 0 1.0547.8544 1.9072 1.9072 1.9072h4.2568l1.4914 5.5937c-.0038.0458-.0267.0839-.0267.1278 0 .3814.1411.7133.3299 1.0108l5.4564 20.46c.2231.8353.9784 1.4151 1.8423 1.4151h20.9788c1.0546 0 1.9071-.8525 1.9071-1.9072 0-1.0527-.8525-1.9071-1.9071-1.9071H30.9309l-1.5257-5.7215h22.945c.9345 0 1.7298-.6732 1.8824-1.5925l1.9071-11.4429c.0916-.5531-.0648-1.1176-.4272-1.5467Z"
        clipRule="evenodd"
      />
      <circle cx="30.3125" cy="58.3125" r="3.3125" fill="#425B9F" />
      <circle cx="49.543" cy="58.3125" r="3.3125" fill="#425B9F" />
      <path
        fill="#AEE1F2"
        d="M51.5913 29.875H27.8984c-.7089 0-1.1699.746-.8529 1.38l2.911 5.822c.1615.3231.4917.5272.8529.5272h19.1184c.4258 0 .8-.2823.9169-.6916l1.6635-5.8221c.174-.6091-.2834-1.2155-.9169-1.2155Z"
      />
      <path
        stroke="#8FA1D2"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2.20833"
        d="m53.6545 16.4617-8.4826 5.9914M41.9623 10.0002l-1.8314 10.1345M28.5625 13.2031l5.8988 8.3515"
      />
    </g>
    <defs>
      <clipPath id="newordericon_clip_path_a">
        <path fill="#fff" d="M0 0h72v72H0z" />
      </clipPath>
    </defs>
  </svg>
);
